// 导出全局web 的MaxAPI
import { overlayManager } from "../../share/ui/overlay/overlayManager"

export const webMaxAPI = {
  overlay: {
    getReceivedData: overlayManager.getReceivedData,
    setRecordData: overlayManager.setRecordData
  },
}